import { BuilderBlocks } from '@builder.io/react';
import React, { CSSProperties, JSX, ReactNode, useEffect, useMemo, useState } from 'react';

// TabsComponent lifted from https://github.com/BuilderIO/builder/blob/main/packages/widgets/src/components/Tabs.tsx

export interface TabsProps {
    tabs: {
        label: ReactNode | ReactNode[];
        content: ReactNode | ReactNode[];
    }[];
    builderBlock: { id: string };
    defaultActiveTab?: number;
    collapsible?: boolean;
    tabHeaderLayout?: string;
    activeTabStyle?: CSSProperties;
}

const TabsComponent = (props: TabsProps): JSX.Element => {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (props.defaultActiveTab) {
            setActiveTab(props.defaultActiveTab - 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const activeTabSpec = useMemo(() => props.tabs?.[activeTab], [activeTab, props.tabs]);

    return (
        <>
            <span
                className="builder-tabs-wrap flex flex-row overflow-auto"
                style={{
                    justifyContent: props.tabHeaderLayout,
                    WebkitOverflowScrolling: 'touch',
                }}
            >
                {props.tabs?.map((item, index) => (
                    <span
                        tabIndex={0}
                        role="button"
                        key={index}
                        className={'builder-tab-wrap ' + (activeTabSpec === item ? 'builder-tab-active' : '')}
                        style={activeTabSpec === item && props.activeTabStyle ? props.activeTabStyle : undefined}
                        onKeyDown={() => {
                            setActiveTab(index === activeTab && props.collapsible ? -1 : index);
                        }}
                        onClick={() => {
                            setActiveTab(index === activeTab && props.collapsible ? -1 : index);
                        }}
                    >
                        <BuilderBlocks
                            parentElementId={props.builderBlock.id}
                            dataPath={`component.options.tabs.${activeTab}.label`}
                            blocks={item.label}
                        />
                    </span>
                ))}
            </span>

            {activeTabSpec && (
                <BuilderBlocks
                    parentElementId={props.builderBlock.id}
                    dataPath={`component.options.tabs.${activeTab}.content`}
                    blocks={activeTabSpec?.content}
                />
            )}
        </>
    );
};

export default TabsComponent;
